// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.viewInformationPills {
  height: 32px;
  display: inline-block;
  margin: 6px;
  background-color: #f2f2f2;
  padding: 6px 12px;
  border-radius: 50px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
}
.viewInformationPills .grayTick {
  width: 15px;
  height: 13px;
  margin-right: 5px;
}`, "",{"version":3,"sources":["webpack://./src/screens/viewInformation/pills/viewInformationPills.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,qBAAA;EACA,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,mBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AACJ;AAAA;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AAEJ","sourcesContent":[".viewInformationPills {\n    height: 32px;\n    display: inline-block;\n    margin: 6px;\n    background-color: #f2f2f2;\n    padding: 6px 12px;\n    border-radius: 50px; \n    font-family: 'Spoqa Han Sans Neo';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px; \n    color: #505054;\n.grayTick{\n    width:15px;\n    height: 13px;\n    margin-right: 5px;\n}\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
